import { useEffect } from 'react'

import { useAccountsUrl } from '../../accounts'
import { useAuth } from '../../auth'

export interface UseRegistrationGuard {
  loadingRedirect: boolean
  shouldRedirect: boolean
}

const useRegistrationGuard = (): UseRegistrationGuard => {
  const { isAuthenticated, isLoading } = useAuth()
  const { redirectToAccount } = useAccountsUrl()

  const loadingRedirect = isLoading
  const shouldRedirect = !isLoading && !isAuthenticated

  useEffect(() => {
    if (shouldRedirect) {
      redirectToAccount({ page: 'checkout' })
    }
  }, [redirectToAccount, shouldRedirect])

  return { loadingRedirect, shouldRedirect }
}

export default useRegistrationGuard
